module.exports = __webpack_public_path__ + "static/media/ic_message_activate.c8faa220.svg";